// extracted by mini-css-extract-plugin
export default {"container":"GDPRPage_container__3U2xS"};